var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85294 1H2.76471C2.29668 1 1.84782 1.18437 1.51687 1.51256C1.18592 1.84075 1 2.28587 1 2.75V13.25C1 13.7141 1.18592 14.1592 1.51687 14.4874C1.84782 14.8156 2.29668 15 2.76471 15H5.85294M6.07227 8H16.0723M12.2513 12L16.0723 8L12.2513 4",
    stroke: "#FF4634",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4728fe2fabb64eb535c6516e2ef7c4ce.svg";
export { ForwardRef as ReactComponent };